import { Fragment } from "react";
import { Routes, Route } from "react-router-dom";

import { ProtectedRoute, routesConfig } from "../utils/route.utils";
import { arrayMap } from "../utils/array.utils";

const AppRoutes = () => {
  const renderRoutes = (route) => {
    const { children, permissions, element, ...rest } = route;

    const newElement = permissions ? (
      <ProtectedRoute requiredPermissions={permissions}>{element}</ProtectedRoute>
    ) : (
      element
    );

    return (
      <Route {...rest} element={newElement}>
        {arrayMap(children, (childRoute, childIndex) => (
          <Fragment key={childIndex + 1}>{renderRoutes(childRoute)}</Fragment>
        ))}
      </Route>
    );
  };

  return (
    <Routes>
      {arrayMap(routesConfig, (route, index) => {
        return <Fragment key={index + 1}>{renderRoutes(route)}</Fragment>;
      })}
    </Routes>
  );
};

export default AppRoutes;
